import { useTheme } from 'styled-components';

interface RecategorisationIconProps {
  secondary?: boolean;
}

export const RecategorisationIcon: React.FC<RecategorisationIconProps> = ({ secondary }) => {
  const theme = useTheme();
  return (
    <svg width="15" height="18" viewBox="0 0 15 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.07694 6.43871L13.9222 5.04212C14.0355 5.02423 14.0344 4.86069 13.9208 4.84436L5.06287 3.5707L5.05362 1.0198C5.05299 0.846907 4.8481 0.756212 4.71969 0.871989L0.227479 4.92229C0.139431 5.00167 0.139373 5.13979 0.227354 5.21925L4.71875 9.2757C4.84675 9.39129 5.05125 9.30153 5.05279 9.12906L5.07694 6.43871Z"
        fill={secondary ? 'rgba(0, 70, 107, 0.25)' : theme.main.deepBlue}
      />
      <path
        d="M9.561 14.8072L0.715788 13.4107C0.602461 13.3928 0.603588 13.2292 0.717151 13.2129L9.57507 11.9392L9.58432 9.38833C9.58495 9.21544 9.78984 9.12474 9.91825 9.24052L14.4105 13.2908C14.4985 13.3702 14.4986 13.5083 14.4106 13.5878L9.91919 17.6442C9.79119 17.7598 9.58669 17.6701 9.58514 17.4976L9.561 14.8072Z"
        fill={secondary ? 'rgba(0, 70, 107, 0.25)' : theme.main.deepBlue}
      />
    </svg>
  );
};
